"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const config_1 = require("../config");
class Cluster {
    constructor(world, algorithm, location, area) {
        this.world = world;
        this.algorithm = algorithm;
        this.location = location;
        this.area = area;
        this.paths = new WeakMap();
    }
    resolve(start, end) {
        if (this.paths.has(start) && this.paths.get(start).has(end))
            return this.paths.get(start).get(end);
        return this.algorithm.getPath(start, end, this.area);
    }
    processEntrances() {
        this.entrances = new Set([
            ...this.processSideEntrances(config_1.Side.NORTH),
            ...this.processSideEntrances(config_1.Side.SOUTH),
            ...this.processSideEntrances(config_1.Side.EAST),
            ...this.processSideEntrances(config_1.Side.WEST),
        ]);
        this.resolveEntrancesPaths();
        return this.getEntrances();
    }
    resolveEntrancesPaths() {
        const paths = this.paths = new WeakMap();
        for (const entrance of this.entrances)
            for (const other of this.entrances)
                if (entrance !== other && (!paths.has(other) || !paths.get(other).has(entrance)))
                    this.addPathsToCache(entrance, other);
    }
    getEntrances() {
        return [...this.entrances];
    }
    getConnections(node) {
        if (!this.paths.has(node))
            for (const entrance of this.entrances)
                this.addPathsToCache(node, entrance);
        return this.paths.get(node);
    }
    addPathsToCache(start, end) {
        const paths = this.paths;
        const path = this.resolve(start, end);
        if (!path)
            return;
        if (!paths.has(start))
            paths.set(start, new Map());
        if (!paths.has(end))
            paths.set(end, new Map());
        path.unshift(start);
        paths.get(start).set(end, path);
        paths.get(end).set(start, [...path].reverse());
        /*
        const color = COLORS[index++ % COLORS.length];
    
        for (const step of path)
          if (!step.color)
            step.color = color;
        */
    }
    processSideEntrances(direction) {
        const tiles = this.getSideTiles(direction);
        const entrances = [];
        for (const tile of tiles) {
            const neighbor = this.world.getNeighbor(tile, direction);
            if (neighbor && !tile.isObstacle && !neighbor.isObstacle)
                entrances.push(tile);
        }
        return this.reduceEntrances(entrances, direction);
    }
    reduceEntrances(entrances, direction) {
        const result = [];
        for (const tile of entrances) {
            let neighborsCount = 0;
            for (const other of entrances) {
                if (tile !== other && tile.isNeighbor(other))
                    neighborsCount++;
            }
            if (neighborsCount === 0 || neighborsCount === 1) {
                // (tile as any).color = 'blue';
                result.push(tile);
            }
        }
        return result;
    }
    getSideTiles(direction) {
        switch (direction) {
            // case Side.UP:
            // case Side.DOWN:
            //   return [].concat(...this.area);
            case config_1.Side.NORTH:
                return this.area.getRow(0);
            case config_1.Side.SOUTH:
                return this.area.getRow(-1);
            case config_1.Side.EAST:
                return this.area.getCol(-1);
            case config_1.Side.WEST:
                return this.area.getCol(0);
        }
        throw new Error(`Unknown side: [${direction}]`);
    }
}
exports.Cluster = Cluster;
const COLORS = ['green', 'orange', 'gray', 'cyan', 'pink', 'purple'];



//////////////////
// WEBPACK FOOTER
// ./src/pathfinding/cluster.ts
// module id = 9
// module chunks = 0